import { Center, Spinner } from "@chakra-ui/react";
import { redirect, useNavigate } from "react-router-dom";

import { RoutesMap } from "../../routes.tsx";
import { useEffectOnce } from "../../utils/hooks";
import { formatPriceToTwoDecimals } from "../../utils";
import { useMakeSbpTransferMutation } from "../../api/sbpTransfer";
import { MakeSbpTransferStatusType } from "../../api/sbpTransfer/types";
import { ITransferResult, useSbpTransferStore } from "../../store/sbpTransferStore";

export const SbpTransferProcessingPage = () => {
  const navigate = useNavigate();
  const { mutateAsync } = useMakeSbpTransferMutation();

  const term = useSbpTransferStore(s => s.term);
  const amount = useSbpTransferStore(s => s.amount);
  const selectedBankSchema = useSbpTransferStore(s => s.selectedBankSchema);
  const selectedBankName = useSbpTransferStore(s => s.selectedBankName);
  const setTransferResult = useSbpTransferStore(s => s.setTransferResult);
  const reset = useSbpTransferStore(s => s.reset);

  useEffectOnce(() => {
    let transferStatus: MakeSbpTransferStatusType | undefined;
    const transferAmount = formatPriceToTwoDecimals(amount);

    void (async () => {
      try {
        const response = await mutateAsync({
          amount: transferAmount,
          bankId: selectedBankSchema,
          trancheProductCode: term?.fasCode || "",
        });

        transferStatus = response.statusCode;
      } catch {
        transferStatus = "ERROR";
      } finally {
        const result: ITransferResult = {
          status: transferStatus || "ERROR",
          amount: transferAmount,
          term,
          bankSchema: selectedBankSchema,
          bankName: selectedBankName,
        };

        reset();
        setTransferResult(result);

        navigate(RoutesMap.sbpTransfer.result);
      }
    }
    )();
  });

  return (
    <Center h="100svh" pb="100px">
      <Spinner />
    </Center>
  );
};

SbpTransferProcessingPage.loader = () => {
  const { amount, term, selectedBankSchema } = useSbpTransferStore.getState();

  if (!amount || !term || !selectedBankSchema) {
    return redirect(RoutesMap.index);
  }

  return null;
};
